import { authorizedInstance } from "../config/axios"

export const getPatientIssuersData = async ({
  page,
  limit,
  sortBy,
  filters,
}) => {
  const query = new URLSearchParams({
    page,
    limit,
    sortBy,
    ...filters,
  })

  const response = await authorizedInstance.get(`/patient-issuers?${query}`)
  return response.data
}

export const getPatientIssuerInfo = async (issuerId) => {
  const response = await authorizedInstance.get(`/patient-issuers/${issuerId}`)
  return response.data
}

export const addPatientIssuer = async (payload) => {
  await authorizedInstance.post("/patient-issuers", payload)
}

export const updatePatientIssuer = async (payload) => {
  const issuerId = payload.issuerId
  delete payload["issuerId"]

  await authorizedInstance.patch(`/patient-issuers/${issuerId}`, payload)
}

export const deletePatientIssuer = async (issuerId) => {
  await authorizedInstance.delete(`patient-issuers/${issuerId}`)
}
